import type { FC, ReactNode } from 'react';

import { PageSubtitle, PageTitle } from 'app/components/Text';

import style from './style.scss';

interface Props {
  title: string;
  subtitle?: string;
  rightContent?: ReactNode;
}

const PageHead: FC<Props> = ({ title, rightContent, subtitle }) => (
  <div className={style.pageHead}>
    <div className={style.titleContainer}>
      <PageTitle>{title}</PageTitle>
      {subtitle && <PageSubtitle>{subtitle}</PageSubtitle>}
    </div>
    {rightContent && <div>{rightContent}</div>}
  </div>
);

PageHead.displayName = 'PageHead';

export default PageHead;
